import { ProfileCategoryService } from "../../services/ProfileCategoryService";
import {
    SET_LOADING,
    SET_PROFILE_CATEGORY_LIST,
} from "./types";

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
    type: SET_LOADING,
    payload: data
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set Profile Category list
 */
export const setProfileCategoryList = (data) => ({
    type: SET_PROFILE_CATEGORY_LIST,
    payload: data
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to get Profile Category list
 */
export const getProfileCategoryList = (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await ProfileCategoryService.getProfileCategoryList({ ...params }).then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setProfileCategoryList(res?.data[0]));
        successCallback?.();
    }).catch(async (err) => {
        console.log("Profile Category list Error: ", err);
        errorCallback?.(err);
    }).finally(() => {
        dispatch(setLoading(false));
    })
};